import { CommonContractorCreateUpdateApp } from '../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp';
import routes from '../../../../../Routes/routes';
import HeadTittle from '../../../../../components/HeadTittle';
import React from 'react';
import { SupplierFlowEmployeeCreateApp } from '../../Funtionality/SupplierCreateUpdateFlows/SupplierFlowEmployeeCreateApp';
import CopySecretModal from '../../../../Dashboard/Company/Employees/Modal/CopySecretModal';
import SupplierFlowEmployeeCreateWithDetails from './SupplierFlowEmployeeCreateWithDetails';
import SupplierFlowEmployeeCreateWithoutDetails from './SupplierFlowEmployeeCreateWithoutDetails';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const SupplierFlowEmployeeCreate = () => {
    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        navigate,
        permission,
        dispatch,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        isValidPassword,
        userInfoStatusList,
        supplierId,
        emptyFields,
        setEmptyFields,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setGeneratedPassword,
        passwordGenerator,
        photoPicker,
        setPhotoPicker,
        handleDateChange,
        handleEmailChange,
        handlePasswordChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        validatePassword,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    } = props;

    const {
        user,
        setUser,
        FormHandler,
        resetForm,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        handleValidateSteps,
        handleChange,
        handleClearExtraData,
    } = SupplierFlowEmployeeCreateApp({
        t,
        permission,
        dispatch,
        setEmptyFields,
        isValidEmail,
        isValidPhoneNumber,
        isValidDob,
        isValidPassword,
        supplierId,
        photoPicker,
        setPhotoPicker,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        validateEmail,
        validatePhone,
        validatePassword,
        isValidDocumentId,
        extraData,
        extraDataEnabled,
        setExtraData,
        setExtraDataEnabled,
        headersList,
    });

    return (
        <>
            <HeadTittle link={routes.suppliers.employees} name={t('create')} />   
            {extraDataEnabled ? (
                <SupplierFlowEmployeeCreateWithDetails
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    resetForm={resetForm}
                    userInfoStatusList={userInfoStatusList}
                    handleValidateSteps={handleValidateSteps}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    extraData={extraData}
                    setExtraData={setExtraData}
                    handleChange={handleChange}
                    headersList={headersList}
                    handleClearExtraData={handleClearExtraData}
                    extraDataEnabled={extraDataEnabled}
                    FormHandler={FormHandler}
                />
            ) : (
                <SupplierFlowEmployeeCreateWithoutDetails
                    steps={steps}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    handleStepChange={handleStepChange}
                    user={user}
                    setUser={setUser}
                    emptyFields={emptyFields}
                    isValidDocumentId={isValidDocumentId}
                    setIsValidDocumentId={setIsValidDocumentId}
                    isValidEmail={isValidEmail}
                    isValidPhoneNumber={isValidPhoneNumber}
                    isValidDob={isValidDob}
                    setIsValidDob={setIsValidDob}
                    handleEmailChange={handleEmailChange}
                    handlePasswordChange={handlePasswordChange}
                    handlePhoneNumberChange={handlePhoneNumberChange}
                    handleDateChange={handleDateChange}
                    resetForm={resetForm}
                    userInfoStatusList={userInfoStatusList}
                    handleValidateSteps={handleValidateSteps}
                    photoPicker={photoPicker}
                    setPhotoPicker={setPhotoPicker}
                    extraData={extraData}
                    headersList={headersList}
                    extraDataEnabled={extraDataEnabled}
                    FormHandler={FormHandler}
                />
            )}
            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.suppliers.employees);
                }}
                closeText={'continue'}
            />
        </>
    );
};
export default SupplierFlowEmployeeCreate;
